import React from 'react';
import { ErrorMessage, useFormikContext } from 'formik';

interface FieldValidation {
  invalid: boolean;
  errorMessage: JSX.Element;
}

function useFieldValidation<T = unknown>(name: keyof T): FieldValidation {
  const { errors, touched } = useFormikContext<T>();
  const errorMessage = <ErrorMessage name={name.toString()} />;
  const invalid = !!(errors[name] && touched[name]);

  return { errorMessage, invalid };
}

export { useFieldValidation };
